import React from "react";
import classes from './Layout.module.css';
import { Outlet } from "react-router-dom";
import ActionBar from "./ActionBar/ActionBar";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { fetchTopicsData } from "../../../store/topic-actions";

const Layout = () => {
    const { backgroundVideo, backgroundImg, backgroundColor } = useSelector((state) => state.application);
    const uiData = useSelector((state) => state.general.uiData);
    const { studyGroupId } = useParams()
    const { studyGroup } = useSelector(state => state.topics);
    const dispatch = useDispatch();
    const { applictionName } = useParams();

    useEffect(() => {
        if (studyGroupId && uiData && studyGroup) {
            dispatch(fetchTopicsData(studyGroupId, applictionName, uiData))
        }
    }, [studyGroupId, uiData, studyGroup])

    return <>
        {backgroundVideo ? <video autoPlay loop muted type='video/mp4' src={backgroundVideo} className={classes.VideoBackground} />
            : <div className={classes.VideoBackground} style={backgroundImg ? { backgroundImage: `url(${backgroundImg})` } : backgroundColor ? { background: backgroundColor } : {}}></div>}
        <div className={classes.LayoutBackground}>

            <div className={classes.CurrentPageContainer}>
                <ActionBar></ActionBar>
                <Outlet></Outlet>
            </div>
        </div>
    </>
}
export default Layout;